// eslint-disable-next-line no-undef
export const waitForMilliseconds = (ms = 1000) => new Promise((res) => setTimeout(res, ms));

export const unwrapPromise = async (promise) => {
  try {
    const result = typeof promise === "function" ? await promise() : await promise;
    return [result, null];
  } catch (err) {
    return [null, err];
  }
};
